import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import { isEqual } from 'lodash';

// 도메인 무관 스위치 프리미티브. size="small"(기본) / "medium" 두 가지.
const StyledSwitch = styled(Switch)(({ theme, size = "small" }) => ({
  width: isEqual(size, "medium") ? 70 : 50,
  height: isEqual(size, "medium") ? 30 : 24,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: isEqual(size, "medium") ? 34 : 30,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: isEqual(size, "medium") ? 'translateX(29px)' : 'translateX(16px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: isEqual(size, "medium") ? 'translateX(32px)' : 'translateX(20px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : theme.palette.primary.main
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: isEqual(size, "medium") ? 34 : 26,
    height: isEqual(size, "medium") ? 26 : 20,
    borderRadius: isEqual(size, "medium") ? 18 : 24,
    transition: theme.transitions.create(['width'], {
      duration: 100,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: isEqual(size, "medium") ? 32 / 2 : 28 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export default StyledSwitch;
